const initialState = {
  account: {
    isLoading: true,
    policy: { manage: false }
  }
}

const startAccountLoading = (state) => ({
  ...state,
  account: {
    ...state.account,
    isLoading: true
  }
})

const stopAccountLoading = (state) => ({
  ...state,
  account: {
    ...state.account,
    isLoading: false
  }
})

const accountLoaded = (state, payload) => ({
  ...state,
  account: {
    ...state.account,
    policy: payload.policy,
  }
})

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case 'GOOGLE_ANALYTICS_FETCH_ACCOUNT':
      return startAccountLoading(state)
    case 'GOOGLE_ANALYTICS_FETCH_ACCOUNT_COMPLETE':
      return stopAccountLoading(state)
    case 'GOOGLE_ANALYTICS_FETCH_ACCOUNT_SUCCESS':
      return accountLoaded(state, payload)
    default:
      return state
  }
}
